(function () {
  function initBlogSection(section) {
    const track = section.querySelector('[data-ff-blog-track]');
    const prevBtn = section.querySelector('[data-ff-blog-prev]');
    const nextBtn = section.querySelector('[data-ff-blog-next]');

    if (!track || !prevBtn || !nextBtn) return;

    const scrollStep = () => {
      const item = track.querySelector('.ff-blog-feed__item');
      if (!item) return track.clientWidth * 0.85;
      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return item.offsetWidth + gap;
    };

    prevBtn.addEventListener('click', () => {
      track.scrollBy({ left: -scrollStep(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', () => {
      track.scrollBy({ left: scrollStep(), behavior: 'smooth' });
    });
  }

  function initAll() {
    document.querySelectorAll('.ff-blog--featured').forEach(initBlogSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.ff-blog--featured') || event.target;
    if (section && section.classList.contains('ff-blog--featured')) {
      initBlogSection(section);
    }
  });
})();
